import cc from 'classcat';

type Orientation = 'left' | 'right';

interface IDiagramArrow {
    onClick: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
    orientation: Orientation;
    disabled: boolean;
}

export const DiagramArrow = ({ onClick, orientation, disabled }: IDiagramArrow) => {
    return (
        <img
            className={cc(['diagram-slider__arrow', `diagram-slider__arrow--${orientation}`, { 'diagram-slider__arrow--disabled': disabled }])}
            onClick={onClick}
            src={`/svg/slider/arrow-${orientation}.svg`}
            alt="diagram-arrow"
        />
    );
};
